/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSchema = createReactComponent("outline", "schema", "IconSchema", [["path", { "d": "M5 2h5v4h-5z", "key": "svg-0" }], ["path", { "d": "M15 10h5v4h-5z", "key": "svg-1" }], ["path", { "d": "M5 18h5v4h-5z", "key": "svg-2" }], ["path", { "d": "M5 10h5v4h-5z", "key": "svg-3" }], ["path", { "d": "M10 12h5", "key": "svg-4" }], ["path", { "d": "M7.5 6v4", "key": "svg-5" }], ["path", { "d": "M7.5 14v4", "key": "svg-6" }]]);

export { IconSchema as default };
//# sourceMappingURL=IconSchema.mjs.map
